export default __webpack_public_path__ + "static/media/share-new.256e1aa6.svg";